import gql from 'graphql-tag';

export const cancelLumeccaTreatment = gql`
  mutation cancelLumeccaTreatment($input: CancelTreatmentInput!) {
    cancelLumeccaTreatment(input: $input) {
      success
    }
  }
`;
